import React from 'react';
import { Banner, Button, Card, Text } from '@shopify/polaris';

export class ErrorBoundary extends React.Component<React.PropsWithChildren, { error: Error | null }> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="admin-login-screen">
          <div className="admin-login-card">
            <Card>
              <div className="admin-stack">
                <Text as="h1" variant="headingLg">Pako AdminApp</Text>
                <Banner tone="critical" title="Інтерфейс зламався на клієнті">
                  <p>{this.state.error.message}</p>
                </Banner>
                <Button onClick={() => window.location.reload()} variant="primary">Перезавантажити</Button>
              </div>
            </Card>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
